import React from "react";
import styled from "styled-components";

import PaywallAssetDiv from "../components/common/PaywallAssetDiv";
import Asset from "../components/asset";

const SingleAssetWrapper = styled.div`
  height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SingleAssetContainer = ({
  asset,
  token,
  branding,
  showPaywall,
  translate,
  children
}) => {
  if (!asset) {
    return <>{children}</>;
  }

  const {
    item: { id: assetId }
  } = asset;

  return (
    <>
      <PaywallAssetDiv
        id={`inplayer-${assetId}`}
        className="inplayer-paywall"
      />
      <SingleAssetWrapper>
        <Asset
          branding={branding}
          token={token}
          data={asset}
          showPaywall={showPaywall}
          id={assetId}
          boxWidth="600px"
          boxHeight="auto"
          previewImgHeight="360px"
          previewFontSize="1.8em"
          descriptionFontSize="1.2em"
          buttonPadding="20px 25px"
          translate={translate}
        />
      </SingleAssetWrapper>
    </>
  );
};

export default SingleAssetContainer;
